var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon14BlogConnector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10.01 10.01 0 0 1 0 20 10.01 10.01 0 0 1 0-20m0-2a12 12 0 0 0 0 24 12 12 0 0 0 0-24z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97 14.66V9.33m6.06 5.33V9.33",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTEyIDJhMTAuMDEgMTAuMDEgMCAwIDEgMCAyMCAxMC4wMSAxMC4wMSAwIDAgMSAwLTIwbTAtMmExMiAxMiAwIDAgMCAwIDI0IDEyIDEyIDAgMCAwIDAtMjR6IiBmaWxsPSIjMDAwIiAvPg0KICAgIDxwYXRoIGQ9Ik04Ljk3IDE0LjY2VjkuMzNtNi4wNiA1LjMzVjkuMzMiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon14BlogConnector as ReactComponent };